// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.SidecarSidebar_sidecarBar__kOaYQ {
  position: absolute;
  top: 0;
  left: 0;
  width: 500px;
  height: 100%;
  flex-shrink: 0;
  background: var(--background-primary, #fff);
  /* ◻️ Light/action_shadow */
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  padding: 20px;
}

.SidecarSidebar_topSection__alyDh {
  margin-bottom: 30px;
}
.SidecarSidebar_topSection__alyDh h1 {
  display: flex;
  justify-content: space-between;
  color: var(--text-primary, #1f2023);
  /* Subheadline/Bold */
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
  letter-spacing: -0.5px;
  margin-bottom: 20px;
}
.SidecarSidebar_topSection__alyDh h1 span {
  cursor: pointer;
  display: flex;
  gap: 10px;
}

.SidecarSidebar_tabBox__6rD8s {
  display: flex;
  width: 100%;
  padding: 2px;
  align-items: flex-start;
  border-radius: 8px;
  border: 1px solid var(--border-tertiary, #e3eaf2);
  background: var(--background-tertiary, #f7f9fc);
}
.SidecarSidebar_tabBox__6rD8s span {
  width: 33%;
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex: 1 0;
  border-radius: 6px;
  cursor: pointer;
  color: var(--text-secondary, #5c6168);
  /* Caption 1/Regular */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
}
.SidecarSidebar_tabBox__6rD8s .SidecarSidebar_activeTab__plrlT {
  background: var(--primary-default, #0c6dc7);
  /* Blue Button Shadow */
  box-shadow: 0px 4px 4px 0px rgba(12, 109, 199, 0.15);
  color: var(--text-on-color, #fff);
  /* Caption 1/Bold */
  font-family: Poppins;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 138.462% */
  letter-spacing: -0.2px;
}

.SidecarSidebar_btmSection__8kJWE {
  width: 100%;
  height: calc(100% - 118px);
}

.SidecarSidebar_alignCenter__zXYjz {
  align-items: center;
}

@media only screen and (max-width: 500px) {
  .SidecarSidebar_sidecarBar__kOaYQ {
    width: 100%;
  }
  .SidecarSidebar_btmSection__8kJWE {
    height: calc(100% - 170px);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/SidecarSidebar/SidecarSidebar.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EAEA,YAAA;EACA,YAAA;EACA,cAAA;EAEA,2CAAA;EAEA,2BAAA;EACA,gDAAA;EACA,aAAA;EAEA,aAAA;AAFD;;AAKA;EACC,mBAAA;AAFD;AAGC;EACC,aAAA;EACA,8BAAA;EAEA,mCAAA;EAEA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,sBAAA;EAEA,mBAAA;AAJF;AAME;EACC,eAAA;EACA,aAAA;EACA,SAAA;AAJH;;AASA;EACC,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EAEA,kBAAA;EACA,iDAAA;EACA,+CAAA;AAPD;AASC;EACC,UAAA;EAEA,aAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EAEA,kBAAA;EACA,eAAA;EAEA,qCAAA;EAEA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AAXF;AAcC;EACC,2CAAA;EAEA,uBAAA;EACA,oDAAA;EAEA,iCAAA;EAEA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,aAAA;EACA,sBAAA;AAfF;;AAmBA;EACC,WAAA;EACA,0BAAA;AAhBD;;AAkBA;EACC,mBAAA;AAfD;;AAkBA;EACC;IACC,WAAA;EAfA;EAiBD;IACC,0BAAA;EAfA;AACF","sourcesContent":[".sidecarBar {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\n\twidth: 500px;\n\theight: 100%;\n\tflex-shrink: 0;\n\n\tbackground: var(--background-primary, #fff);\n\n\t/* ◻️ Light/action_shadow */\n\tbox-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.05);\n\tz-index: 1000;\n\n\tpadding: 20px;\n}\n\n.topSection {\n\tmargin-bottom: 30px;\n\th1 {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\n\t\tcolor: var(--text-primary, #1f2023);\n\n\t\t/* Subheadline/Bold */\n\t\tfont-family: Poppins;\n\t\tfont-size: 16px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 20px; /* 125% */\n\t\tletter-spacing: -0.5px;\n\n\t\tmargin-bottom: 20px;\n\n\t\tspan {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\tgap: 10px;\n\t\t}\n\t}\n}\n\n.tabBox {\n\tdisplay: flex;\n\twidth: 100%;\n\tpadding: 2px;\n\talign-items: flex-start;\n\n\tborder-radius: 8px;\n\tborder: 1px solid var(--border-tertiary, #e3eaf2);\n\tbackground: var(--background-tertiary, #f7f9fc);\n\n\tspan {\n\t\twidth: 33%;\n\n\t\tdisplay: flex;\n\t\tpadding: 5px 10px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t\tflex: 1 0 0;\n\n\t\tborder-radius: 6px;\n\t\tcursor: pointer;\n\n\t\tcolor: var(--text-secondary, #5c6168);\n\n\t\t/* Caption 1/Regular */\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.2px;\n\t}\n\n\t.activeTab {\n\t\tbackground: var(--primary-default, #0c6dc7);\n\n\t\t/* Blue Button Shadow */\n\t\tbox-shadow: 0px 4px 4px 0px rgba(12, 109, 199, 0.15);\n\n\t\tcolor: var(--text-on-color, #fff);\n\n\t\t/* Caption 1/Bold */\n\t\tfont-family: Poppins;\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: 18px; /* 138.462% */\n\t\tletter-spacing: -0.2px;\n\t}\n}\n\n.btmSection {\n\twidth: 100%;\n\theight: calc(100% - 118px);\n}\n.alignCenter{\n\talign-items: center;\n}\n\n@media only screen and (max-width: 500px) {\n\t.sidecarBar {\n\t\twidth: 100%;\n\t}\n\t.btmSection {\n\t\theight: calc(100% - 170px);\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidecarBar": `SidecarSidebar_sidecarBar__kOaYQ`,
	"topSection": `SidecarSidebar_topSection__alyDh`,
	"tabBox": `SidecarSidebar_tabBox__6rD8s`,
	"activeTab": `SidecarSidebar_activeTab__plrlT`,
	"btmSection": `SidecarSidebar_btmSection__8kJWE`,
	"alignCenter": `SidecarSidebar_alignCenter__zXYjz`
};
export default ___CSS_LOADER_EXPORT___;
